<template>
	<div class="gb-page">
		<HeadNav selectedLanguage="en" page="dmca" />

		<article class="gb-legal">
			<hh1>DMCA Policy</hh1>
			<p>
				<a class="jump-url" href="https://gbappss.co/">GB Apps</a>
				respects intellectual property rights and responds to valid copyright infringement claims.
			</p>
			<p>
				If you believe that any content on our website violates your copyright, please contact us with detailed
				information about the material.
			</p>

			<hh2>Copyright Removal Request</hh2>
			<p>A valid DMCA request should include:</p>
			<ul>
				<li>Your name and contact information</li>
				<li>Identification of the copyrighted content</li>
				<li>The URL of the material in question</li>
				<li>A statement confirming ownership of the copyright</li>
				<li>Your request for removal</li>
			</ul>
			<p>After receiving a valid request, we will review the information and take appropriate action.</p>

			<hh2>Contact</hh2>
			<p>For copyright-related requests:</p>
			<p>
				<strong>Email:</strong>
				<a class="jump-url" href="mailto:contact@gbappss.co">contact@gbappss.co</a>
			</p>
		</article>
	</div>
</template>

<script>
import '@/css/base.scss'
import '@/css/index.scss'
import '@/css/gbappss.scss'
import HeadNav from '@/components/HeadNav.vue'

export default {
	name: 'Dmca',
	components: { HeadNav },
}
</script>
